export { fetchQuesCreateChapter, dismissFetchQuesCreateChapterError } from './fetchQuesCreateChapter';
export { setFontSize } from './setFontSize';
export { fetchSubmitQues, dismissFetchSubmitQuesError } from './fetchSubmitQues';
export { fetchAddCollecton, dismissFetchAddCollectonError } from "../../center/redux/fetchAddCollecton";
export { fetchAddQuestionNote, dismissFetchAddQuestionNoteError } from "../../center/redux/fetchAddQuestionNote";
export { fetchAddQuestionerrorCorrection, dismissFetchAddQuestionerrorCorrectionError } from "../../center/redux/fetchAddQuestionerrorCorrection";
export { fetchGetQuesChapter, dismissFetchGetQuesChapterError } from './fetchGetQuesChapter';
export { updateCheckParsIndex } from './updateCheckParsIndex';
export { updateCheckAllPars } from './updateCheckAllPars';
export { updateCurQuesIndex } from './updateCurQuesIndex';
export { fetchSubmitPra, dismissFetchSubmitPraError } from './fetchSubmitPra';
export { fetchQuesContinueChapter, dismissFetchQuesContinueChapterError } from './fetchQuesContinueChapter';
export { fetchQuesExam, dismissFetchQuesExamError } from './fetchQuesExam';
export { fetchGetExamQuesList, dismissFetchGetExamQuesListError } from './fetchGetExamQuesList';
export { fetchGetExamDetail, dismissFetchGetExamDetailError } from './fetchGetExamDetail';
export { fetchGetExamPageResult, dismissFetchGetExamPageResultError } from './fetchGetExamPageResult';
export { updateQuesTypeIndex } from './updateQuesTypeIndex';



// WEBPACK FOOTER //
// ./src/features/ques-store/redux/actions.js